import React from 'react';
import { Container } from 'react-bootstrap';
import CompanyDetails from '../components/details/CompanyDetails';

const Details = () => (
  <Container className="p-1">
    <CompanyDetails />
  </Container>
);

export default Details;
